module.exports = __webpack_public_path__ + "static/media/one-core-color-palette-documentation.8e00a4f3.png";